import { Field, Form, Formik } from 'formik';
import React, { Fragment, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PageHelmet from 'components/common/Helmet';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import { Title } from 'components/title/Title';
import { getReference } from 'utils';
import { registrationSchema } from 'utils/validationSchemas';
import Loader from 'components/Loader';
// import * as typeformEmbed from '@typeform/embed'
// import { SignInFacebook } from '../login/SignInFacebook';
import { SignInGoogle } from 'components/login/SignInGoogle';
// import { SignInTwitter } from '../login/SignInTwitter';
import { useRavePayment } from "react-ravepayment";


const ERROR_CODE_EMAIL_ACCOUNT_EXISTS = 'auth/email-already-in-use';

const ERROR_MSG_EMAIL_ACCOUNT_EXISTS = `
  An account with this E-Mail address already exists.
  Try to login with this account instead. If you think the
  account is already used from one of the social logins, try
  to sign-in with one of them. Afterward, associate your accounts
  on your personal account page.
`;

// const prodMode = process.env.REACT_APP_MODE === 'prod'

export const SignUp = (props) => {
	const { firebase, authUser } = props
	const [error, setError] = useState({})
	const [loading, setLoading] = useState(false)
	const [registered, setRegistered] = useState(false)
	const [config, ] = useState({
		txref: getReference(),
		customer_email: 'hello@infinitycomics.tv',
		customer_phone: 256778123456,
		amount: 500,
		PBFPubKey: process.env.REACT_APP_IC_DEV_RAVE_PBFPUBKEY,
		production: false,
		pay_button_text: "Get Started",
		country: "UG",
		currency: "UGX",
		payment_method: ["card, mobilemoneyuganda, barter"],
		// payment_plan: prodMode ? 3409 : null,
		close: () => history.push('/account'),
		redirect_url: '/account'
	})

	const history = useHistory()

	const handleOnSuccess = (data) => {
		firebase
			.user(authUser.uid)
			.update({
				subscribed: true,
				transactionId: data.tx.raveRef
			})
		history.push('/account')
	}

	const handleOnClose = () => {
		history.push('/account')
	}

	// const handleRaveConfig = (data) => {
	// 	setConfig({
	// 		txref: getReference(),
	// 		customer_email: data.email || 'hello@infinitycomics.tv',
	// 		customer_phone: data.phone || 25677123456,
	// 		amount: data.amount || 500,
	// 		PBFPubKey: process.env.REACT_APP_IC_DEV_RAVE_PBFPUBKEY,
	// 		production: false,
	// 		pay_button_text: "Get Started",
	// 		country: "UG",
	// 		currency: "UGX",
	// 		payment_method: ["card, mobilemoneyuganda, barter"],
	// 		// payment_plan: prodMode ? 3409 : null,
	// 		close: () => history.push('/account'),
	// 		redirect_url: '/account'
	// 	})
	// }

	const handleRegistration = (values, actions) => {
		setLoading(true)
		firebase
			.createUserWithEmailAndPassword(values.email, values.password)
			.then(newUser => {
				if (newUser) {
					// handleRaveConfig({email: values.email, phone: values.phoneNumber})
					firebase.auth.onAuthStateChanged(user => {

						setRegistered(true);
						// handleRaveConfig({email: values.email, phone: values.phoneNumber})
						user.sendEmailVerification()
							.then(() => {
								setRegistered(true);
								// handleRaveConfig({email: values.email, phone: values.phoneNumber})
							})
							.catch(err => {
								setError(err)
								setLoading(false)
								actions.setSubmitting(false);
							});

						user.updateProfile({
							displayName: values.firstName + ` ` + values.lastName
						})
							.then(() => {
								firebase
									.user(newUser.user.uid)
									.set({
										email: values.email,
										name: values.firstName,
										surname: values.lastName,
										phone: values.phoneNumber,
										subscribed: false,
										transactionId: ''
									});
							})
							.catch(err => {
							setError(err);
								setLoading(false)
								actions.setSubmitting(false);
						});
					})
				}
			})
			.catch(err => {
				if (err.code === ERROR_CODE_EMAIL_ACCOUNT_EXISTS) {
					err.message = ERROR_MSG_EMAIL_ACCOUNT_EXISTS;
				}
				setError(err);
			});
		setLoading(false)
		actions.setSubmitting(false);
	}

	const openPopup = () => {

		initializePayment(handleOnSuccess, handleOnClose)

		return (
			<button className="w-100 rn-button-style--2 btn-solid" onClick={() => initializePayment(handleOnSuccess, handleOnClose)} name="registration">Complete Registration</button>
		)
	}

	const { initializePayment } = useRavePayment(config);

	return (
		<Fragment>
			<PageHelmet pageTitle='Sign Up' />

			<Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

			<Title title='Get Started' />

			<div className="contact-form--1 pt--50 pb--50">
				<div className="container">
					<div className="row row--35 align-items-center justify-content-center">
						<div className="col-lg-6">
							{loading
								? <Loader />
							: (<Formik
								initialValues= {{
									firstName: '',
									lastName: '',
									email: '',
									phoneNumber: '',
									password: '',
									confirmPassword: ''
								}}
								validationSchema= {registrationSchema}
								onSubmit={handleRegistration}
							>
								{({ errors, getFieldProps, handleSubmit, isSubmitting, touched }) => (
									<div className="form-wrapper">
										{ registered
												? history.push('/account')
												: (<div>
														<div className="row mt--20 mb--20 justify-content-center">
															<SignInGoogle text='Sign Up' popup1={openPopup} setError={setError} setRegistered={setRegistered} />
															{/*<SignInFacebook popup1={popup1} setError={setError} setRegistered={setRegistered} />*/}
															{/*<SignInTwitter popup1={popup1} setError={setError} />*/}
														</div>
														<Form onSubmit={handleSubmit}>
															<p className="mt--20 text-center">OR</p>

															<label htmlFor="firstName">
																Your First Name
															</label>
															<div className="form-input">
																<Field placeholder="Your First Name" id="firstName" {...getFieldProps('firstName')} />
																<p className="error">{touched.firstName && errors.firstName}</p>
															</div>

															<label htmlFor="lastName">
																Your Last Name
															</label>
															<div className="form-input">
																<Field placeholder="Your Last Name" id="lastName" {...getFieldProps('lastName')} />
																<p className="error">{touched.lastName && errors.lastName}</p>
															</div>

															<label htmlFor="email">Your Email</label>
															<div className="form-input">
																<Field required label="Your Email" placeholder="name@example.com" id="email" {...getFieldProps('email')} />
																<p className="error">{touched.email && errors.email}</p>
															</div>

															<label htmlFor="phoneNumber">Your Phone Number</label>
															<div className="form-input">
																<Field required label="Your Phone Number" placeholder="0712345678" id="phoneNumber" {...getFieldProps('phoneNumber')} />
																<p className="error">{touched.phoneNumber && errors.phoneNumber}</p>
															</div>

															<label htmlFor="password">Password</label>
															<div className="form-input">
																<Field required icon='lock' id="password" type="password" placeholder="************" {...getFieldProps('password')} />
																<p className="error">{touched.password && errors.password}</p>
															</div>

															<label htmlFor="confirmPassword">Confirm Password</label>
															<div className="form-input">
																<Field required id="confirmPassword" type="password" placeholder="************" {...getFieldProps('confirmPassword')} />
																<p className="error">{touched.confirmPassword && errors.confirmPassword}</p>
															</div>

															<p className="error">{error.message}</p>

															<div className="row--35 text-center">
																<div className="col mt--50">
																	<button className="w-100 rn-button-style--2 btn-solid" disabled={isSubmitting} type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Get Started</button>
																	<h4 className="mt--30"><Link to='/login' >Already have an account ? Sign In</Link></h4>
																</div>
															</div>
														</Form>
													</div>
											)
										}

									</div>
								)}
							</Formik>)}
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	)
}


